import axios from 'axios';
import { handleShellSessionExpiry } from '@/shells/services/sessionExpiry';
const client = axios.create({ baseURL: process.env.VUE_APP_API || '', timeout: 30000, withCredentials: true, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
client.interceptors.request.use(config => {
  const token = localStorage.getItem('user_access_token');
  if (token) config.headers.authorization = `Bearer ${token}`;
  return config;
});
client.interceptors.response.use(response => response, error => {
  const status = error && error.response && error.response.status;
  handleShellSessionExpiry(status);
  const failure = new Error(status === 403 ? 'Tu suscripción no permite acceder a este contenido.' : status === 404 ? 'No encontramos este informe.' : 'No se pudo cargar el contenido. Inténtalo de nuevo.');
  failure.status = status;
  return Promise.reject(failure);
});
export default client;
